var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 133,
    viewBox: "0 0 132 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12841",
    "data-name": "Group 12841",
    transform: "translate(908 -11904)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_396",
    "data-name": "Ellipse 396",
    cx: 66,
    cy: 66.5,
    rx: 66,
    ry: 66.5,
    transform: "translate(-908 11904)",
    fill: "#fdeebe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wedding-ring",
    transform: "translate(-881 11932.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4400",
    "data-name": "Path 4400",
    d: "M25.988,137.076a20.988,20.988,0,1,1,20.988-20.988A21.006,21.006,0,0,1,25.988,137.076Zm0-37.494a16.506,16.506,0,1,0,16.506,16.506A16.527,16.527,0,0,0,25.988,99.582Z",
    transform: "translate(0 -77.9)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4401",
    "data-name": "Path 4401",
    d: "M41.988,111.1A20.986,20.986,0,0,0,26.1,145.8a20.986,20.986,0,0,0,29.6-29.6A20.909,20.909,0,0,0,41.988,111.1Zm0,37.494a16.5,16.5,0,0,1-12.7-5.971,16.5,16.5,0,1,1,23.236-23.236,16.5,16.5,0,0,1-10.535,29.207Z",
    transform: "translate(-13.834 -91.734)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4402",
    "data-name": "Path 4402",
    d: "M41.988,111.1A20.986,20.986,0,0,0,26.1,145.8a20.986,20.986,0,0,0,29.6-29.6A20.909,20.909,0,0,0,41.988,111.1Zm0,37.494a16.5,16.5,0,0,1-12.7-5.971,16.5,16.5,0,1,1,23.236-23.236,16.5,16.5,0,0,1-10.535,29.207Z",
    transform: "translate(-13.834 -91.734)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4403",
    "data-name": "Path 4403",
    d: "M217.988,239.076a20.988,20.988,0,1,1,20.988-20.988A21.006,21.006,0,0,1,217.988,239.076Zm0-37.494a16.506,16.506,0,1,0,16.506,16.506A16.527,16.527,0,0,0,217.988,201.582Z",
    transform: "translate(-166.002 -166.089)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4404",
    "data-name": "Path 4404",
    d: "M231.988,211.1a18.009,18.009,0,1,0,13.852,5.24A21.006,21.006,0,0,0,231.988,211.1Zm0,37.494a16.5,16.5,0,1,1,16.506-16.506A16.482,16.482,0,0,1,231.988,248.594Z",
    transform: "translate(-178.107 -178.193)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4405",
    "data-name": "Path 4405",
    d: "M321.9,125.034h0a3.155,3.155,0,0,0-4.482,0,3.169,3.169,0,0,0-4.482,4.482L317.416,134l4.482-4.482A3.154,3.154,0,0,0,321.9,125.034Z",
    transform: "translate(-265.431 -102.973)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4406",
    "data-name": "Path 4406",
    d: "M122.738,5l2.139,4.739-6.432,7.447L112,9.739,114.166,5Z",
    transform: "translate(-92.512)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4407",
    "data-name": "Path 4407",
    d: "M116.306,9.739,114.166,5,112,9.739Z",
    transform: "translate(-92.512)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4408",
    "data-name": "Path 4408",
    d: "M179.692,9.739,177.553,5,175.4,9.739Z",
    transform: "translate(-147.327)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4409",
    "data-name": "Path 4409",
    d: "M148.006,9.739,145.853,5,143.7,9.739Z",
    transform: "translate(-119.919)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4410",
    "data-name": "Path 4410",
    d: "M143.7,40l2.139,7.447L148.006,40Z",
    transform: "translate(-119.919 -30.261)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4411",
    "data-name": "Path 4411",
    d: "M277.836,209.81v.311a16.361,16.361,0,0,1,4.4-2.207,20.559,20.559,0,0,0-.88-4.414,20.458,20.458,0,0,0-4.157,1.747A16.883,16.883,0,0,1,277.836,209.81Z",
    transform: "translate(-235.343 -171.622)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4412",
    "data-name": "Path 4412",
    d: "M286.822,208.97a16.35,16.35,0,0,1,2.505-1.056,20.565,20.565,0,0,0-.88-4.414,19.708,19.708,0,0,0-3.047,1.178A17.008,17.008,0,0,1,286.822,208.97Z",
    transform: "translate(-242.432 -171.622)",
    fill: "#4c5b71",
    stroke: "#4c5b71",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingIcon);
export default __webpack_public_path__ + "static/media/RingIcon.7ab81e5c2820b6e4fe06a0b75f27fc2c.svg";
export { ForwardRef as ReactComponent };